import React, { useState } from 'react';
import { IImageEmbedNoteFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import styled from 'styled-components';
import NoteActions from '../NoteActions';
import ImageEmbed from '../../../../ImageEmbed';
import * as NoteUI from '../NoteUI';
import { IconWrapper, SvgIcon } from '../../../../Icon';
import {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core';

interface IImageNoteProps {
  noteId: string;
  content: IImageEmbedNoteFieldsFragment;
  dragHandleProps?: {
    attributes: DraggableAttributes;
    listeners?: DraggableSyntheticListeners;
  };
}

const Container = styled(NoteUI.Container)`
  min-height: 300px;
  display: flex;
  flex-direction: column;
  margin: 8px 0;
`;

const ImageContainer = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
  width: 100%;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

const ImageNote = ({ noteId, content, dragHandleProps }: IImageNoteProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Container>
      <NoteUI.Header
        onMouseOver={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <NoteUI.Row>
          <IconWrapper size={16}>
            {isHovered && dragHandleProps && (
              <NoteUI.DragHandle
                name="drag-drop"
                width={12}
                height={12}
                {...dragHandleProps.attributes}
                {...dragHandleProps.listeners}
              />
            )}
            {!isHovered && <SvgIcon name="image" width={16} height={16} />}
          </IconWrapper>
          <NoteUI.Name>Image</NoteUI.Name>
        </NoteUI.Row>
        <NoteActions noteId={noteId} />
      </NoteUI.Header>
      <ImageContainer>
        <ImageEmbed imageEmbed={content.imageEmbed} />
      </ImageContainer>
    </Container>
  );
};

export default ImageNote;
